import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { CompanyAttachmentService } from 'src/app/services/core/company-attachment/company-attachment.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';

@UntilDestroy()
@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.css']
})
export class AttachmentListComponent implements OnInit {
  @Input() companyId: any;
  search: any = '';
  attachements: any;
  filteredAttachments: any;
  logObj:any=null;

  currentPage: number = 1;
  numberOfRecords = NUMBER_OF_RECORDS;
  totalPages = 0;
  totalResults = 0;
  selectedDropdownIndex:any;
  toggleActionButtons = false;

  private readonly searchSubject = new Subject<string | undefined>();

  attachmentModalObj: any;

  constructor(
    private attachmentService: CompanyAttachmentService
  ) { }

  ngOnInit() {
    this.getAttachments(this.currentPage);
    this.initializeSearch();
  }

  getAttachments(page: number) {
    let queryParams: any = {
      limit: this.numberOfRecords,
      page,
      sortBy: 'createdAt:desc',
    }
    if (this.search) {
      queryParams.search = this.search.trim();
    }
    this.attachmentService.getCompanyAttachments(this.companyId, queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.attachements = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  async deleteAttachment(attachment: any) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to delete this attachment?`,
      "warning",
      "Yes",
      "No"
    );
    if (result.value) {
      this.attachmentService
        .delete(attachment.id)
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.getAttachments(this.currentPage);
        });
    }
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAttachments(page);
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAttachments(this.currentPage)
      });
  }

  openAttachmentEditModal(attachement: any) {
    this.attachmentModalObj = attachement;
  }

  onSaveAttachment(evt: any) {
    this.attachmentModalObj = null;
    this.getAttachments(this.currentPage);
  }
  
  onCloseAttachmentModal() {
    this.attachmentModalObj = null;
  }
  openLogModal(driver:any){
    this.logObj = driver.id;
  }
  showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }
}
